import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class TransloadOrders_ds_get_licenseplate_associations_by_shipment_idService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { shipment_id: number }): 
  Promise<{ result: { LicensePlateId?: number, Shipmentid?: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.shipment_id)) {
      missingRequiredInParams.push('\'shipment_id\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { shipment_id: number, $top?: number, $skip?: number }): 
  Promise<{ result: { LicensePlateId?: number, Shipmentid?: number }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.shipment_id)) {
      missingRequiredInParams.push('\'shipment_id\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { shipment_id: number, $keys: { LicensePlateId?: number, Shipmentid?: number }[] }): 
  Promise<{ result: { LicensePlateId?: number, Shipmentid?: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.shipment_id)) {
      missingRequiredInParams.push('\'shipment_id\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      shipment_id: number    }) {
        if(isNil(inParams.shipment_id)) {
          return true; 
        }
      return false;
    }
}
